module.exports = __webpack_public_path__ + "static/media/gbps.01270768.png";